import Modal from 'components/Modal';
import {FC, useState} from 'react';
import {useFormContext} from 'react-hook-form';
import {t} from 'ttag';
import {setUrl} from 'utils/request';
import {onApiError, onApiSuccess} from 'utils/request-axios/utils';

import {useExport} from './services';

type UseExportHistoryDataModalFn = (exporter: Exporter) => {
    exporter: Exporter;
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
};
export const useExportHistoryDataModal: UseExportHistoryDataModalFn = (
    exporter,
) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    return {exporter, isModalOpen, setIsModalOpen};
};

type Exporter = 'document-archive' | 'history_entries' | 'sending-order';
type ExportHistoryDataModalProps = {
    exporter: Exporter;
    isModalOpen: boolean;
    setIsModalOpen: (isOpen: boolean) => void;
};
const ExportHistoryDataModal: FC<ExportHistoryDataModalProps> = ({
    exporter,
    isModalOpen,
    setIsModalOpen,
}) => {
    const methods = useFormContext();

    const apiExport = useExport();

    const handleExport = async (format: string) => {
        let formData = {
            exporter: exporter,
            fmt: format,
        };
        const queryParameters = new URLSearchParams(window.location.search);

        queryParameters.forEach((value, key) => {
            if (key !== 'page') {
                formData = {...formData, [key]: value};
            }
        });

        await apiExport
            .mutateAsync({formData})
            .then(
                onApiSuccess({
                    onRedirect: (response) => {
                        if (response.name === 'history_downloads_view') {
                            return setUrl(window.Urls.async_download_view());
                        }

                        throw new Error('Unknown redirect');
                    },
                }),
            )
            .catch(onApiError(methods));
    };

    return (
        <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <Modal.Header>
                <div className="flex items-center justify-between">
                    <div>{t`Export`}</div>
                    <Modal.Button
                        icon="close"
                        kind="tertiary"
                        onClick={() => setIsModalOpen(false)}
                        size="sm"
                        type="cancel"
                    />
                </div>
            </Modal.Header>
            <Modal.Body>
                <p>{t`Please select an export format.`}</p>
                <p>
                    {t`When choosing CSV, it is recommended to use UTF-8. When exporting with Shift JIS/CP932, unsupported characters will be replaced with ? characters.`}
                </p>
            </Modal.Body>
            <Modal.Footer>
                <Modal.Button
                    kind="secondary"
                    onClick={() => handleExport('xls')}
                    size="sm"
                    type="submit"
                >
                    {t`Excel`}
                </Modal.Button>
                <Modal.Button
                    kind="secondary"
                    onClick={() => handleExport('csv_cp932')}
                    size="sm"
                    type="submit"
                >
                    {t`CSV (Japanese, Shift JIS\CP932)`}
                </Modal.Button>
                <Modal.Button
                    kind="secondary"
                    onClick={() => handleExport('csv_utf8')}
                    size="sm"
                    type="submit"
                >
                    {t`CSV (UTF-8)`}
                </Modal.Button>
            </Modal.Footer>
        </Modal>
    );
};
export default ExportHistoryDataModal;
